<template>
  <el-col :span="12" class="air-col-8">
    <img :src="require(`@/img/tiles/${icon}`)" />
    <div class="titleIng">
      <div>
        <p>男：<span class="title_color">{{ maleValue }}</span></p>
        <p>女：<span class="title_color">{{ femaleValue }}</span></p>
      </div>
      <p>{{ title }}</p>
    </div>
  </el-col>
</template>

<script>

export default {
  name: "airQualityIndicator",
  data() {
    return {};
  },
  props: ['title', 'maleValue', 'femaleValue', 'icon'],
  watch: { },
  methods: { },
  mounted() {}
};
</script>

<style scoped>
.air-col-8 {
height: 80%;
display: flex;
flex-direction: row;
align-items: center;
}

.air-col-8 img {
height: 70%;
margin: 0 8%;
}

.titleIng {
text-align: left;
}

.titleIng p {
margin-top: 7px;
color: rgb(69, 162, 255);
text-align: left;
font-size: 1vw;
}

.titleIng > div > p {
font-weight: 600;
}

.titleIng > p {
text-align: center;
font-size: 1vw;
}

.title_color {
color: #fff;
font-size: 1vw;
}
</style>



// WEBPACK FOOTER //
// src/components/html/airQualityIndicator.vue